export const coursesData = [
    {
        "id": 1,
        slug: "bsc-hons-global-business-and-entrepreneurship-with-foundation-year",
        "course_name": "BA (Hons) Global Business and Entrepreneurship with Foundation Year",
        "category": "Business & Finance",
        "url": "/Courses/",
        // "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/v1768736358/banner-2_zvhllj.webp",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941396/course1_r7hotx.avif",
        "duration": "4 years",
        "intakes": "October, January, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/2eidzck3/group-1000004575.jpg"
      },
      {
        "id": 2,
        "slug": "bsc-business-and-tourism-management",
        "course_name": "BSc (Hons) Business and Tourism Management",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941400/course2_coykin.avif",
        "duration": "4 years",
        "intakes": "September, January, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/nxvnmtnu/group-1000004524-1.jpg"
      },
      {
        "id": 3,
        "slug": "ba-hons-global-business-with-foundation-year",
        "course_name": "BA (Hons) Global Business (Business Management) with Foundation Year",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769942444/course3_ypnwqu.avif",
        "duration": "4 years",
        "intakes": "October, February, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/vpofzpqo/group-1000004576.jpg"
      },
      {
        "id": 4,
        "slug": "bsc-project-management-with-foundation-year",
        "course_name": "BSc (Hons) Project Management with Foundation Year",
        "category": "Project Management",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941404/course4_ht1msc.avif",
        "duration": "4 years ",
        "intakes": "October, February, June",
        "theme_color": "#8E7DBE",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 5,
        "course_name": "BSc (Hons) Applied Business Psychology with Foundation Year",
        "category": "Psychology",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941404/course5_aw2gq2.avif",
        "duration": "4 years",
        "intakes": "October, February, June",
        "theme_color": "#CD5656",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 6,
        "course_name": "HND in Business",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769942564/course6_cc3gu6.avif",
        "duration": "2 years",
        "intakes": "October, January, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/qa4b5not/untitled-design-12.png"
      },
      {
        "id": 7,
        "course_name": "MSc Global Business",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941396/course7_szqdgn.jpg",
        "duration": "1 year",
        "intakes": "October, February, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 8,
        "course_name": "BSc (Hons) Health, Wellbeing and Social Care with Foundation Year",
        "category": "Health & Social Care",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941396/course8_qdfjqj.avif",
        "duration": "4 Years",
        "intakes": "October, January, June",
        "theme_color": "#F39E60",
        "partner_logo": "/media/pctgvpun/gbs_oxford-brooks-university_logo_rgb-1.jpg"
      },
      {
        "id": 9,
        "course_name": "HND in Health and Social Care Practice",
        "category": "Health & Social Care",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941440/course9_zbbgdt.jpg",
        "duration": "2 years",
        "intakes": "October, January, June",
        "theme_color": "#F39E60",
        "partner_logo": "/media/qa4b5not/untitled-design-12.png"
      },
      {
        "id": 10,
        "course_name": "BSc (Hons) Computing with Foundation Year",
        "category": "Digital Technologies & Computing",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941429/course10_kcphbq.jpg",
        "duration": "4 years ",
        "intakes": "October, February, June",
        "theme_color": "#659287",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 11,
        "course_name": "HND in Digital Technologies for England (Cyber Security)",
        "category": "Digital Technologies & Computing",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941430/course11_zpnr9g.avif",
        "duration": "2 years",
        "intakes": "October, January, June",
        "theme_color": "#659287",
        "partner_logo": "/media/qa4b5not/untitled-design-12.png"
      },
      {
        "id": 12,
        "course_name": "BSc (Hons) Construction Management with Foundation Year",
        "category": "Construction Management",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941431/course12_w3v0lr.avif",
        "duration": "4 years",
        "intakes": "October, February, June",
        "theme_color": "#FADA7A",
        "partner_logo": "/media/3vlkse1z/group-1000004573.png"
      },
      {
        "id": 13,
        "course_name": "HND in Construction Management for England (Construction Design and Build Technician)",
        "category": "Construction Management",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941431/course13_ofdfem.jpg",
        "duration": "2 years",
        "intakes": "October, January, June",
        "theme_color": "#FADA7A",
        "partner_logo": "/media/qa4b5not/untitled-design-12.png"
      },
      {
        "id": 14,
        "slug": "bsc-accounting-and-financial-management",
        "course_name": "BSc (Hons) Accounting and Financial Management",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941424/course14_dhn4dx.jpg",
        "duration": "4 years",
        "intakes": "September, January, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/nxvnmtnu/group-1000004524-1.jpg"
      },
      {
        "id": 15,
        "slug": "bsc-hons-business-and-management",
        "course_name": "BA (Hons) Business and Management (Level 6 Top-Up)",
        "category": "Business & Finance",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941426/course15_chuwd8.jpg",
        "duration": "1 year",
        "intakes": "October, February, June",
        "theme_color": "#9ECAD6",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 16,
        "course_name": "BSc (Hons) Health, Wellbeing and Social Care (Level 6 Direct Entry)",
        "category": "Health & Social Care",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769942927/course16_tfybjp.jpg",
        "duration": "1 Year",
        "intakes": "October, January, June",
        "theme_color": "#F39E60",
        "partner_logo": "/media/qsmfh123/gbs_oxford-brooks-university_logo_rgb-1.jpg"
      },
      {
        "id": 17,
        "course_name": "BSc (Hons) Construction Management (Level 6 Top-Up)",
        "category": "Construction Management",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941425/course17_ws88gh.webp",
        "duration": "1 year",
        "intakes": "October, February, June",
        "theme_color": "#FADA7A",
        "partner_logo": "/media/3vlkse1z/group-1000004573.png"
      },
      {
        "id": 18,
        "course_name": "MSc Project Management",
        "category": "Project Management",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941427/course18_etw7ic.avif",
        "duration": "1 year",
        "intakes": "September, February, June",
        "theme_color": "#8E7DBE",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 19,
        "course_name": "BSc (Hons) Psychology with Counselling with Foundation Year",
        "category": "Psychology",
        "url": "/Courses/",
       
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_800,c_fill,f_auto,q_auto:good,fl_progressive,fl_strip_profile/v1769941427/course18_etw7ic.avif",
        // "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_500,q_auto:low,f_auto/v1769941431/course19_jsmslf.avif",
        "duration": "4 years ",
        "intakes": "September, February, June",
        "theme_color": "#CD5656",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      },
      {
        "id": 20,
        "course_name": "MSc Counselling and Psychotherapy",
        "category": "Psychology",
        "url": "/Courses/",
        "image": "https://res.cloudinary.com/dg0eeyvud/image/upload/w_800,c_fill,f_auto,q_auto:good,fl_progressive,fl_strip_profile/v1769941427/course18_etw7ic.avif",
        

        "duration": "1 year",
        "intakes": "September, February, June",
        "theme_color": "#CD5656",
        "partner_logo": "/media/5uxmwrke/group-1000004573.jpg"
      }
];